import { render, staticRenderFns } from "./ExamenClinico.vue?vue&type=template&id=d45b9a08"
import script from "./ExamenClinico.vue?vue&type=script&lang=ts"
export * from "./ExamenClinico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports